import { Component, OnInit, ViewChild } from '@angular/core';
import { ListService, PagedResultDto } from '@abp/ng.core';
import { Column } from '../shared/components/metro-table/metro-table.component';
import { GetWineryDto, WineryDto } from '../proxy/wineries/models';
import { WineryFormComponent } from './create-edit-winery/winery-form.component';
import { ConfirmationModalService } from '../shared/services/confirmation-modal.service';
import { WineryService } from '@proxy/wineries';
import { Router } from '@angular/router';

@Component({
  selector: 'app-wineries',
  templateUrl: './wineries.component.html',
  providers: [ListService], // 👈 importante!
  standalone: false,
})
export class WineriesComponent implements OnInit {
  columns: Column[] = [
    { name: 'name', label: '::Name', width: '20%' },
    { name: 'country', label: '::Country', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'contactName', label: '::Contact', width: '15%', textColor: 'text-metro-blue-secondary' },
    { name: 'email', label: '::Email', width: '20%', textColor: 'text-metro-blue-secondary' },
  ];

  actions: any[] = [
    { name: 'edit', label: '::Edit', handler: (row: WineryDto) => this.openEditModal(row) },
    { name: 'delete', label: '::Delete', handler: (row: WineryDto) => this.deleteWinery(row) },
  ];

  data: PagedResultDto<WineryDto> = { items: [], totalCount: 0 };
  searchWinery = {} as GetWineryDto;
  isLoading = true;

  showWineryModal = false;
  selectedWinery: WineryDto | null = null;

  @ViewChild(WineryFormComponent) wineryForm?: WineryFormComponent;

  constructor(
    public readonly list: ListService,
    private wineriesService: WineryService,
    private confirmation: ConfirmationModalService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const streamCreator = (query) =>
      this.wineriesService.getList({ ...this.searchWinery, ...query });

    this.list.hookToQuery(streamCreator).subscribe((result) => {
      this.data = result;
      this.isLoading = false;
    });
  }

  onSearch(searchTerm: string) {
    this.isLoading = true;
    this.searchWinery.keyword = searchTerm;
    this.list.page = 0;
    this.list.get();
  }

   onClearSearch() {
    this.isLoading = true;
    this.searchWinery = {} as GetWineryDto;
    this.list.page = 0;
    this.list.get();
  }

  handleWinerySaved(winery: WineryDto) {
    this.list.get();
    this.showWineryModal = false;
  }

  openCreateModal() {
    this.router.navigate(['/wineries/create']);
  }

  openEditModal(winery: WineryDto) {
  this.router.navigate(['/wineries/edit', winery.id]);
}

  deleteWinery(winery: WineryDto) {
    this.confirmation.confirm({
      title: '::AreYouSureToDelete',
      message: '::ThisActionCannotBeUndone',
      type: 'danger',
      showCancelButton: true,
    }).subscribe((confirmed) => {
      if (!confirmed) return;
      this.wineriesService.delete(winery.id).subscribe(() => this.list.get());
    });
  }

  onPageChange(page: number) {
    this.isLoading = true;
    this.list.page = page - 1;  // Convert from 1-indexed (used by metro-table) to 0-indexed (used by ABP ListService)
    this.list.get();
  }
}
